export function LoginMethodComponent({
  callback,
}: {
  callback: {
    onSelectPhone: () => void;
    onSelectEmail: () => void;
  };
}) {
  return (
    <div className="px-4 w-full mt-20 lg:mt-0 lg:w-1/2 xl:w-1/3 flex lg:items-center lg:justify-center">
      <div className="w-full sm:w-4/6 lg:w-3/4 mx-auto bg-surface flex flex-col gap-12">
        <h1 className="hidden lg:block d-header-1 text-font-primary">
          Sign up
        </h1>
        <div className="flex flex-col gap-10">
          <div className="w-full">
            <p className="header-2 text-font-primary">
              How would you like to sign in?
            </p>
            <p className="body-2 text-font-secondary pt-1">
              Choose your preferred login method
            </p>
          </div>
          <div className="flex flex-col w-full gap-4">
            <button
              onClick={() => callback.onSelectPhone()}
              className="border border-outline bg-container-low py-4 px-6 rounded-xl w-full text-font-primary outline-none hover:border-primary focus:border-primary transition-colors flex items-center justify-between group"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                  <img
                    src="/icons/call-primary.svg"
                    alt="Phone login"
                    className="w-5 h-5"
                  />
                </div>
                <div className="text-left">
                  <p className="subheader-1 text-font-primary">
                    Login with Phone
                  </p>
                  <p className="body-2 text-font-secondary">
                    Use your phone number
                  </p>
                </div>
              </div>
              <img
                src="/icons/arrow-primary.svg"
                alt="Arrow"
                className="h-5 w-5 opacity-50 group-hover:opacity-100 transition-opacity"
              />
            </button>
            <button
              onClick={() => callback.onSelectEmail()}
              className="border border-outline bg-container-low py-4 px-6 rounded-xl w-full text-font-primary outline-none hover:border-primary focus:border-primary transition-colors flex items-center justify-between group"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                  <img
                    src="/icons/email-primary.svg"
                    alt="Email login"
                    className="w-5 h-5"
                  />
                </div>
                <div className="text-left">
                  <p className="subheader-1 text-font-primary">
                    Login with Email
                  </p>
                  <p className="body-2 text-font-secondary">
                    Use your email address
                  </p>
                </div>
              </div>
              <img
                src="/icons/arrow-primary.svg"
                alt="Arrow"
                className="h-5 w-5 opacity-50 group-hover:opacity-100 transition-opacity"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginMethodComponent;
